import axios from 'axios'

function createRequest () {
  const baseURL = 'https://www.glo.or.th/'

  const instance = axios.create({
    baseURL,
    validateStatus: () => (true)
  })

  /**
   * before send request
   * add Authorization header
   */



  /**
   * after get response data
   * convert response style to [error, result]
   */

  instance.interceptors.response.use(
    (response) => {
      const { data } = response

      const { response: res } = data
      return [res]
    }, () => {
    }
  )

  return instance
}

export default createRequest()